import { render, staticRenderFns } from "./WidgetCongratulation.vue?vue&type=template&id=2b65fbc2"
import script from "./WidgetCongratulation.vue?vue&type=script&lang=js"
export * from "./WidgetCongratulation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports